// src/components/common/modal/ModalElements.tsx

import { Box, Divider, IconButton, styled } from '@mui/material';

export const SectionContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  '&:last-child': {
    marginBottom: 0,
  },
}));

export const SectionDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(0.75, 0),
  border: `2px dashed ${theme.palette.dividerContrast}`,
}));

export const InputContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

export const IncrementButton = styled(IconButton)(({ theme }) => ({
  width: '2.9rem',
  height: '2.9rem',
  padding: 0,
  border: `3px solid ${theme.palette.primary.main}`,
  borderRadius: '3px',
  color: theme.palette.primary.main,
  backgroundColor: 'transparent',
  transition: 'all 0.2s ease',

  '@media (hover: hover)': {
    '&:hover': {
      backgroundColor:
        theme.palette.mode === 'dark'
          ? theme.palette.secondary.light
          : theme.palette.error.light,
      borderColor:
        theme.palette.mode === 'dark'
          ? theme.palette.secondary.main
          : theme.palette.error.main,
      color:
        theme.palette.mode === 'dark'
          ? theme.palette.secondary.main
          : theme.palette.error.main,
    },
  },

  '&:active': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? theme.palette.secondary.light
        : theme.palette.error.light,
    borderColor:
      theme.palette.mode === 'dark'
        ? theme.palette.secondary.main
        : theme.palette.error.main,
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.secondary.main
        : theme.palette.error.main,
  },

  '&:disabled': {
    opacity: 0.9,
    cursor: 'not-allowed',
    borderColor: theme.palette.action.disabled,
    color: theme.palette.action.disabled,
  },

  '& svg': {
    fontSize: '2rem',
  },
}));

export const IncrementButtonLarge = styled(IconButton)<{ disabled?: boolean }>(
  ({ theme, disabled }) => ({
    width: '4rem',
    height: '4rem',
    borderRadius: '8px',
    border: `2px solid ${theme.palette.divider}`,
    backgroundColor: disabled
      ? theme.palette.action.disabledBackground
      : 'transparent',
    color: disabled ? theme.palette.text.disabled : theme.palette.primary.main,
    transition: 'all 0.2s ease',
    flexShrink: 0,

    '&:hover:not(:disabled)': {
      backgroundColor: theme.palette.action.hover,
      borderColor: theme.palette.primary.main,
    },

    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },

    '& svg': {
      fontSize: '2.4rem',
    },
  })
);

export const ManagerFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  justifyContent: 'center',
  marginTop: theme.spacing(2),
  paddingTop: theme.spacing(2),
  borderTop: `3px dashed ${theme.palette.dividerContrast}`,
}));

export const DatePickerFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(5),
  justifyContent: 'center',
  marginTop: theme.spacing(0),
  minHeight: '5rem',
  alignItems: 'flex-start',
  paddingTop: theme.spacing(0),
  '@media(max-width: 600px)': {
    gap: theme.spacing(1),
  },
}));
